import { render, staticRenderFns } from "./JobPortalList.vue?vue&type=template&id=6a6d6bc0&scoped=true"
import script from "./JobPortalList.vue?vue&type=script&lang=js"
export * from "./JobPortalList.vue?vue&type=script&lang=js"
import style0 from "./JobPortalList.vue?vue&type=style&index=0&id=6a6d6bc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6d6bc0",
  null
  
)

export default component.exports